import { SET_SHIPMENT_PAYMENT_METHODS, type SetShipmentPaymentMethods } from '~shared/actions/shipmentPaymentMethods';
import { SET_SHIPMENTS, type SetShipments } from '~shared/actions/shipments';
import { type Shipment, type ShipmentPaymentMethod } from '~shared/types';

export type ShipmentsState = {
  lastRequestAttemptedAt: number;
  requestAttemptCount: number;
  lastRequestSucceededAt: number;
  shipments: Shipment[];
  shipmentPaymentMethods: ShipmentPaymentMethod[];
};

const initialState: ShipmentsState = {
  lastRequestAttemptedAt: 0,
  requestAttemptCount: 0,
  lastRequestSucceededAt: 0,
  shipments: [],
  shipmentPaymentMethods: [],
};

const shipments = (
  state: ShipmentsState = initialState,
  action: SetShipments | SetShipmentPaymentMethods,
): ShipmentsState => {
  switch (action.type) {
    // Bridged from React Query (useShipmentsReduxBridge). Keep lastRequestSucceededAt /
    // requestAttemptCount populated so the existing shipments timestamp selectors keep working.
    case SET_SHIPMENTS:
      return { ...state, lastRequestSucceededAt: Date.now(), requestAttemptCount: 0, shipments: action.payload };

    case SET_SHIPMENT_PAYMENT_METHODS:
      return { ...state, shipmentPaymentMethods: action.payload };

    default:
      return state;
  }
};

export default shipments;
